import SchoolTableGrid from "./schoolTableGrid"
export default SchoolTableGrid;